let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2dw9h")).then(() => parcelRequire('i7wi3'));